module.exports = __webpack_public_path__ + "img/118ne.7e045dc5.svg";